import React from 'react';
import styles from '../styles/PlaceCard.module.css';
import { Lugar } from '../api/api';

interface PlaceCardProps {
  lugar: Lugar;
  onClose: () => void;
}

/* util para la primera foto */
const getImageUrl = (fotos: any): string =>
  !fotos ? '' : Array.isArray(fotos) ? fotos[0] : fotos;

const PlaceCard: React.FC<PlaceCardProps> = ({ lugar, onClose }) => {
  /* URL pública de Google Maps, no necesita API-key */
 const embedUrl =
  `https://maps.google.com/maps?q=${lugar.latitud},${lugar.longitud}` +
  `&z=15&output=embed&iwloc=near`;
  const imageUrl = getImageUrl(lugar.fotos);

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.placeCard}>
        <button className={styles.closeButton} onClick={onClose}>
          ✕
        </button>

        <h2 className={styles.title}>{lugar.nombre}</h2>

        {imageUrl && (
          <img
            src={imageUrl}
            alt={`Foto de ${lugar.nombre}`}
            className={styles.cardImage}
          />
        )}

        {lugar.descripcion && <p className={styles.desc}>{lugar.descripcion}</p>}

        {/* MINI-MAPA */}
        <div className={styles.mapWrapper}>
          <iframe
            src={embedUrl}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={`Mapa de ${lugar.nombre}`}
          ></iframe>
        </div>

        {lugar.horario && (
          <p>
            <strong>Horario:</strong> {lugar.horario}
          </p>
        )}
        {lugar.tiempoVisita && (
          <p>
            <strong>Tiempo de Visita estimado:</strong> {lugar.tiempoVisita} min
          </p>
        )}
      </div>
    </div>
  );
};

export default PlaceCard;
